import React, { Component } from 'react';

import Grid from '@material-ui/core/Grid';

import DateCell from './DateCell.js';

class DateRow extends Component {

  onCellClick

  constructor(props) {
    super(props);
    this.week = props.week
    this.onCellClick = props.onCellClick

    this.cells = []
    for (var i = 0; i < this.week.length; i++) {
      var day = this.week[i];
      this.cells.push(<DateCell key={day.desc} day={day} onClick={this.onCellClick}/>)
    }
  }

  render() {
    return (
      <Grid container>
        {this.cells}
      </Grid>
    );
  }
}

export default DateRow;



// WEBPACK FOOTER //
// ./src/comps/DateRow.js